import { Mail, Send } from "lucide-react";
import { useState, type FormEvent } from "react";
import toast from "react-hot-toast";
import { Button } from "../ui/Button";
import { Reveal } from "../ui/Reveal";

/**
 * ⚠️ Ainda não existe endpoint de newsletter no backend: o formulário valida o
 * e-mail e avisa que o recurso está chegando, sem prometer inscrição.
 */
export const Newsletter = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    toast("Newsletter em breve! Ainda estamos preparando nossos envios. 🥷");
    setEmail("");
  };

  return (
    <section aria-labelledby="newsletter-title" className="px-4 pb-24 sm:px-6 lg:px-8">
      <Reveal className="mx-auto max-w-7xl">
        <div className="relative isolate overflow-hidden rounded-[2rem] border border-line bg-card p-8 sm:p-12 lg:flex lg:items-center lg:justify-between lg:gap-12">
          <div aria-hidden="true" className="absolute -left-24 -top-24 -z-10 size-72 rounded-full bg-primary/10 blur-3xl" />
          <div className="flex items-center gap-5">
            <span className="hidden size-16 shrink-0 place-items-center rounded-2xl bg-primary text-night sm:grid">
              <Mail className="size-7" aria-hidden="true" />
            </span>
            <div>
              <h2 id="newsletter-title" className="font-display text-4xl leading-none tracking-wide sm:text-5xl">
                Receba <span className="text-primary">novidades</span>
              </h2>
              <p className="mt-2 text-sm text-muted">Lançamentos e promoções ninja direto no seu e-mail.</p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="mt-8 flex w-full flex-col gap-3 sm:flex-row lg:mt-0 lg:max-w-md">
            <label htmlFor="newsletter-email" className="sr-only">
              Seu e-mail
            </label>
            <input
              id="newsletter-email"
              type="email"
              required
              autoComplete="email"
              placeholder="Digite seu e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="field h-[52px] rounded-full px-6"
            />
            <Button type="submit" size="lg" icon={<Send className="size-4" aria-hidden="true" />}>
              Inscrever
            </Button>
          </form>
        </div>
      </Reveal>
    </section>
  );
};
